import { Navigate, Outlet, useSearchParams } from "react-router-dom";

import { useGetCurrentUser } from "~/api/users/users";
import createBg from "~/assets/onboarding/create-account.svg";
import {
  AuthImageProvider,
  useAuthImage,
} from "~/features/auth/context/AuthImageContext";
import ErrorBoundaryWrapper from "../ErrorBoundaryWrapper";
import { SplitLayout } from "./SplitLayout";

const AuthLayoutContent = () => {
  const { imageSrc } = useAuthImage();

  return (
    <SplitLayout imageSrc={imageSrc}>
      <Outlet />
    </SplitLayout>
  );
};

export const AuthLayout = () => {
  const { data: userInfo } = useGetCurrentUser();
  const [searchParams] = useSearchParams();

  if (userInfo && userInfo.role !== "GUEST") {
    const retpath = searchParams.get("retpath");
    const to = retpath ? decodeURIComponent(retpath) : "/";
    return <Navigate to={to} replace />;
  }

  return (
    <ErrorBoundaryWrapper>
      <AuthImageProvider defaultImage={createBg}>
        <AuthLayoutContent />
      </AuthImageProvider>
    </ErrorBoundaryWrapper>
  );
};
